import { useEffect, useRef } from 'react';

const useTimer = (atendimentoIniciado, setTempoAtendimento) => {
  const timerRef = useRef(null);

  // Efeito para gerenciar o timer
  useEffect(() => {
    if (atendimentoIniciado) {
      // Inicia o timer
      timerRef.current = setInterval(() => {
        setTempoAtendimento(prevTempo => prevTempo + 1);
      }, 1000);
    } else {
      // Para o timer se não estiver em atendimento
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }

    // Limpa o timer quando o componente é desmontado
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [atendimentoIniciado, setTempoAtendimento]);

  // Função para parar o timer manualmente
  const pararTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  return {
    timerRef,
    pararTimer
  };
};

export default useTimer; 